module.exports = __webpack_public_path__ + "assets/img/starter_directory_explain.bedbc65d.jpg";